import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TrendsGraph, TrendsGroupType, TrendsMultipleGraphRequest, TrendsState } from "./trendsTypes";
import { trendApi } from "../../../app/apislices/trendApi";
import * as _ from "lodash-es";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useEffect } from "react";

const initialState: TrendsState = {
  isDialogOpen: false,
  groupBy: "measuringPoints",
  graphs: [],
};

const trendsSlice = createSlice({
  name: "trendsSlice",
  initialState,
  reducers: {
    setIsDialogOpen: (state, action: PayloadAction<boolean>) => {
      state.isDialogOpen = action.payload;
    },
    setGroupBy: (state, action: PayloadAction<TrendsGroupType>) => {
      state.groupBy = action.payload;
    },
    addGraph: (state, action: PayloadAction<TrendsGraph>) => {
      if (
        !state.graphs.some(
          (x) => x.analysisCategory === action.payload.analysisCategory && x.measuringPoint === action.payload.measuringPoint
        )
      )
        state.graphs.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(trendApi.endpoints.postTrendGetTable.matchFulfilled, (state, action) => {
      state.graphs = [];
    });
  },
});

export const selectGraphGroups = createSelector(
  [(state) => state.trends.graphs, (state) => state.trends.groupBy],
  (graphs: TrendsGraph[], groupBy) =>
    groupBy === "measuringPoints" ? _.groupBy(graphs, "measuringPoint") : _.groupBy(graphs, "analysisCategory")
);

export const { setIsDialogOpen, setGroupBy, addGraph } = trendsSlice.actions;

export default trendsSlice.reducer;

export const useGetTrendGraphs = (options: TrendsMultipleGraphRequest) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const subscriptions = options.graphs.map((graph) => {
      return dispatch(trendApi.endpoints.postTrendGetGraph.initiate({ ...graph, analysisRequestId: options.analysisRequestId }));
    });
    return () => {
      for (const subscription of subscriptions) {
        subscription.unsubscribe();
      }
    };
  }, [dispatch, options]);

  return useAppSelector((state) => {
    return options.graphs.map((graph) => {
      return trendApi.endpoints.postTrendGetGraph.select({ ...graph, analysisRequestId: options.analysisRequestId })(state);
    });
  });
};

trendApi.enhanceEndpoints({
  endpoints: {
    postTrendGetTable: {
      providesTags: [],
    },
    postTrendGetGraph: {
      providesTags: [],
    },
  },
});
